import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CodeWithMeLogo } from '@jetbrains/logos/react';
import NavigationLink from '@app/common/navigation/navigation-link';
import { TitledBlock } from '@app/common/titled-block/titled-block';
export function CWMDisabled() {
    return (_jsxs(TitledBlock, { title: "Code With Me", titleLogo: _jsx(CodeWithMeLogo, {}), children: ["Code With Me Enterprise offers real-time synchronous collaboration for developers within your organization.", _jsx("br", {}), "Enable the product on the", ' ', _jsx(NavigationLink, { href: "/configuration/license-activation", children: "License & Activation" }), ' ', "page."] }));
}
